var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBriefcase = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M26.956 12.234c0-1.511 0-2.267-.166-2.887A4.875 4.875 0 0 0 23.343 5.9c-.62-.166-1.375-.166-2.886-.166-1.511 0-2.267 0-2.887.166a4.875 4.875 0 0 0-3.447 3.447c-.166.62-.166 1.376-.166 2.887m-4.55 22.748h22.099c1.82 0 2.73 0 3.425-.354a3.25 3.25 0 0 0 1.42-1.42c.355-.695.355-1.605.355-3.425v-12.35c0-1.82 0-2.73-.355-3.425a3.25 3.25 0 0 0-1.42-1.42c-.695-.354-1.605-.354-3.425-.354H9.408c-1.82 0-2.73 0-3.426.354a3.25 3.25 0 0 0-1.42 1.42c-.354.696-.354 1.606-.354 3.425v12.35c0 1.82 0 2.73.354 3.425a3.25 3.25 0 0 0 1.42 1.42c.696.354 1.606.354 3.426.354Z",
  stroke: "currentColor",
  strokeWidth: 3.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgBriefcase;